module.exports = __webpack_public_path__ + "static/media/1609182_754711704878_1392501825_o.50ba2381.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/makeup_hair/1609182_754711704878_1392501825_o.jpg
// module id = 347
// module chunks = 0